<template>
	<div class="page-container">
		<e-nav :type="1"></e-nav>
		<div class="introduce-container">
			<label class="title">唱工委介绍</label>	
			<div class="content">
				<p>中国音像与数字出版协会唱片工作委员会（简称“唱工委”）是中国音像与数字出版协会所属的专业工作组织，是集合音乐产业中唱片公司、版权公司、音乐发行公司等音乐从业者的行业协会。唱工委作为中国唱片业与中国政府密切联系的桥梁和纽带，是中国境内（含内地、台湾、香港、澳门）代表唱片行业的全国性、非营利性的行业社团。唱工委接受中国新闻出版广电总局和中国民政部的业务指导和监督管理。</p>
				<p>唱工委致力于维护会员的合法权益、加强行业自律、推进中国著作权法的完善、繁荣中国唱片产业，推动中国音乐国际市场化的进程。</p>
				<p>唱工委会员单位聚集了最优质的华语音乐版权，涵盖了国内• 中国音像与数字出版协会唱片工作委员会（简称“唱工委”），英文名称：China Music Industry Committee （英文缩写：ＣＭＩＣ）。</p>
				<p>唱工委是中国音像与数字出版协会所属的专业工作委员会，是集合音乐产业中唱片公司、版权公司、音乐发行公司等音乐从业者的行业组织。唱工委于2003在北京获准成立，作为中国唱片业与中国政府密切联系的桥梁和纽带，是中国境内代表唱片行业的全国性、非营利性的行业社团。唱工委接受国家新闻出版署和中国民政部的业务指导和监督管理。</p>
			</div>
		</div>
		<div class="introduce-container">
			<label class="title">唱工委职能</label>	
			<div class="content">
				<p>唱工委以发展和繁荣中国唱片产业，促进国家的精神文明建设，加强对唱片内容制作企业的协调和管理，推动中国唱片业与国际音乐市场的交流和合作，维护成员的合法权益，充分激发唱片行业在引领中国音乐产业发展中的重要作用。</p>
				<p>集合了中国地区的音乐公司、版权公司、发行公司等内容资源，形成了规模最大、资源最优、价值最大的华语音乐版权资源行业联盟，有效的促进了版权交易和拓展。</p>
				<p>建立健康的数字音乐产业价值链。代表音乐产业版权方的核心利益，发挥强大的谈判能力，平衡版权方与互联网渠道方的利益分配机制，共同探索数字音乐产业的经营模式，逐步完善合理的授权模式、规范的交易模式、产品定价模式。</p>
				<p>维护录音制作者的合法权益，打击盗版，推动《中国著作权法》修法。依托专业的法律工作小组，代表会员集体维权、诉讼。为中国音乐知识产权保护接轨国际水准，不断参与《中国著作权法》的提案、修订。</p>
				<p>定期发布行业信息、统计行业数据，每年编撰《中国音乐产业市场调研报告》。传递行业心声，展开与政府、媒体、公众的对话。</p>
				<p>创办唱工委音乐奖（CMIC Music Awards简称ＣＭＡ）,CMA是中国首个由唱片行业协会发起设立的音乐奖项。</p>
				<p>举办音乐论坛和奖项，协办中国音乐产业大会、中国原创音乐致敬盛典、中国音乐金钟奖、金唱片奖、首都文化博览会。</p>
				<p>推动中国唱片业与国际音乐市场的交流与合作。与IFPI（HK）、RIT、RIAJ、KOCCA、RIM、CAVCA、CAPDA、MIDEM、Brits、Billboard等机构保持着紧密的联系。</p>
			</div> 
		</div>
	</div>
</template>

<script>
import eNav from '@/components/Nav'
export default {
	name: 'introduce',
	components: {
		eNav
	},
	data () { 
		return {
		}
	},
	mounted: function() {},
	methods:{}
}
</script>
<style lang="scss" scoped>
	.introduce-container {
		padding: 30px 0;

		.title {
			font-size: 20px;
			color: #181413;
			line-height: 20px;
		}

		.content {
			p{
				margin: 0;
				padding: 16px 0;
				font-size: 14px;
				color: #888178;
				line-height: 24px;
				text-align: justify;
			}
		}
	}
</style>

